<template>
    <div>
        <el-button
            size="mini"
            :disabled="readonly || disabled"
            @click="selectOrg"
            icon="el-icon-plus"
            type="primary"
            round
        >{{ placeholder }}</el-button>
        <org-items
            :value="value"
            :closable="!disabled"
            @remove="$emit('input', value)"
        />
        <OrgPicker
            :title="title"
            :showOrgPicker.sync="isShowDialog"
			ref="orgPicker"
			:checkedData="userIdList"
			@updateCheckedData="updateCheckedPerson"
			:isPersonLevel="true"
			:isCheckLeafOnly="isCheckLeafOnly"
			:isSingleCheck="!multiple"
			:isAppendToBody="false"
			:isMergeUser="false"
            v-bind="$attrs"
		/>
    </div>
</template>
  
<script>
import OrgPicker from "./OrgPicker.vue"
import OrgItems from "./OrgItems.vue";
  
export default {
    name: "OrgUserPicker",
    components: { OrgPicker, OrgItems },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "请选择"
        },
        multiple: {
            type: Boolean,
            default: true
        },
        value: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        },
        // 选择人员弹框名称
		title: {
			type: String,
			default: '选择人员',
		},
        // 是否只能选择叶子节点
		isCheckLeafOnly: {
			type: Boolean,
			default: false,
		},
    },
    data() {
        return {
            showOrgSelect: false,
            isShowDialog: false,
        }
    },
    computed: {
        userIdList() {
            // console.log(this.value.map(item => `${item.deptCode}-${item.userId}`), 233)
            if(Array.isArray(this.value)) {
                // return this.value.map(item => item.userId)
                return this.value.map(item => `${item.deptCode}-${item.userId}`)
            } else {
                return []
            }
        }
    },
    methods: {
        selectOrg() {
            this.isShowDialog = true
        },
        updateCheckedPerson(select) {
            console.log(select, 233)
            const data = select.map(item => ({...item, userId: item.originUserId}))
            this.$emit("input", data)
        },
        selected(select) {
            const len = select.length
            if (len > this.$attrs.max) {
             select.splice(len - 1, 1)
            }
            this.$emit("input", [...select])
        }
    }
}
</script>
  
<style lang="less" scoped>
    .desc {
        font-size: small;
        color: #8c8c8c;
    }
    .org-item {
        margin: 5px;
    }
</style>
  